export default __webpack_public_path__ + "static/media/landing-abilities-side-image.1c2dffcd.png";